class ActionError extends Error {
  public statusCode: number;
  public errorCode?: string;

  constructor(
    message: string,
    statusCode: number | null | undefined,
    errorCode?: string | null | undefined
  ) {
    super(message);
    this.name = this.constructor.name;
    this.statusCode = statusCode || 500;
    this.errorCode = errorCode || '';
    Object.setPrototypeOf(this, new.target.prototype);
  }

  public toJSON(): Record<string, unknown> {
    return {
      name: this.name,
      message: this.message,
      statusCode: this.statusCode,
      errorCode: this.errorCode,
      stack: this.stack,
    };
  }

  public static fromJSON(json: {
    message: string;
    statusCode?: number;
    errorCode?: string;
    stack?: string;
  }): ActionError {
    const { message, statusCode, errorCode } = json;
    const error = new ActionError(message, statusCode, errorCode);
    if (json.stack) {
      error.stack = json.stack;
    }
    return error;
  }
}

export default ActionError;
